/** @jsxImportSource solid-js */
import { onCleanup, type Setter } from "solid-js";

export function useDebounce<T>(signalSetter: Setter<T>, delay: number) {
  let timerHandle: ReturnType<typeof setTimeout>;
  function debouncedSignalSetter(value: T) {
    clearTimeout(timerHandle);
    timerHandle = setTimeout(() => signalSetter(value), delay);
  }
  onCleanup(() => clearInterval(timerHandle));
  return debouncedSignalSetter;
}
